const ToolkitIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 3.5H16.5C16.7321 3.5 16.9558 3.58073 17.1338 3.72656L17.207 3.79297C17.3946 3.9805 17.5 4.23478 17.5 4.5V7.25H20.25C20.6562 7.25 21.0479 7.3912 21.3594 7.64648L21.4873 7.7627C21.8155 8.09088 22 8.53587 22 9V19.5C22 19.7321 21.9193 19.9558 21.7734 20.1338L21.707 20.207C21.5195 20.3946 21.2652 20.5 21 20.5H3C2.76791 20.5 2.54417 20.4193 2.36621 20.2734L2.29297 20.207C2.10543 20.0195 2 19.7652 2 19.5V9L2.00879 8.82715C2.04288 8.48362 2.17764 8.15762 2.39648 7.89062L2.5127 7.7627C2.84088 7.43451 3.28587 7.25 3.75 7.25H6.5V4.5C6.5 4.26791 6.58073 4.04417 6.72656 3.86621L6.79297 3.79297C6.95711 3.62883 7.17237 3.52757 7.40137 3.50488L7.5 3.5ZM2.5 20H21.5V12.25H14.5V16H9.5V12.25H2.5V20ZM10 15.5H14V12.25H10V15.5ZM3.75 7.75C3.45995 7.75 3.18043 7.85098 2.95801 8.0332L2.86621 8.11621C2.63179 8.35063 2.5 8.66848 2.5 9V11.75H21.5V9C21.5 8.70995 21.399 8.43043 21.2168 8.20801L21.1338 8.11621C20.8994 7.88179 20.5815 7.75 20.25 7.75H3.75ZM7 7.25H17V4H7V7.25Z"
      stroke="currentColor"
    />
  </svg>
);

export default ToolkitIcon;
